import Box, { Item } from 'devextreme-react/box';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Loader } from '../../../../components/loader/Loader';
import { useBreadcrumbs } from '../../../../contexts/breadcrumbsContext';
import { useTranslation } from '../../../../contexts/translation';
import { TasksServiceDeskUpdateForm } from '../../../../forms/tasks/TasksServiceDeskUpdateForm';
import { DetailPageParams } from '../../../../types/pageParams.types';
import { Task } from '../../../../types/task.types';
import { API_URL, fetcher } from '../../../../utils/apiUrl';
import { swrConfig } from '../../../Assets/AssetsEdit';

export const tabsIndexes = {
  COMMENTS: 0,
  FILES: 1,
  HISTORY: 2,
  WORKSHEETS: 3,
};

export const TaskServiceDeskUpdate = () => {
  const { translate } = useTranslation();
  const transFormName = 'Task.UpdateServiceDesk';
  const { setValue } = useBreadcrumbs();
  const { id } = useParams<DetailPageParams>();

  const [currentTab, setCurrentTab] = useState<number>(tabsIndexes.COMMENTS);

  useEffect(() => {
    setValue({
      pageName: 'Edit task',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Tasks', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  // Task
  const {
    data: task,
    isValidating: taskIsValidating,
    mutate: mutateTask,
  } = useSWR<Task>(`${API_URL.TASK_ITEM}?id=${Number(id)}`, fetcher, swrConfig);

  if (!task || taskIsValidating) return <Loader />;

  return (
    <>
      <div className={'content-block'}>
        <TasksServiceDeskUpdateForm
          task={task}
          defaultValues={{
            id: task.id,
            taskName: task.taskName,
            description: task.description,
            diagnose: task.diagnose,
            responsiblePersonId: task.responsiblePersonId,
            customerId: task.customerId,
            customerProjectId: task.customerProjectId,
            typeId: task.typeId,
            topLevelAssetId: task.assetTopLevelParenId,
            assetId: task.assetId,
            priorityId: task.priorityId,
            capacityCategoryId: task.capacityCategoryId,
            faultTypeId: task.faultTypeId || null,
            requiredDate: task.requiredDate,
            requestorName: task.requestorName,
            requestorEmail: task.requestorEmail,
            requestorPhone: task.requestorPhone,
            statusNameTranslated: task.statusNameTranslated,
            downtimeFrom: task.downtimeFrom,
            downtimeTo: task.downtimeTo,
            creationTime: task.creationTime,
            billingStatus: task.billingStatus,
          }}
          onActionDone={() => mutateTask()}
          comments={task.comments}
        />
        <div style={{ marginTop: 15 }}>
          <Box direction="row" crossAlign="start" align="space-between">
            <Item ratio={0.742}></Item>
          </Box>
        </div>
      </div>
    </>
  );
};
